import { get } from 'lodash-es';
import { getPathWithArgs } from 'object-path-generator';
/**
 * @deprecated don't add anything new into deprecatedTestIds
 * avoid using for new test ids
 */ export const overrideTestIds = (deprecatedTestIds)=>function(path) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        const oldTestId = get(deprecatedTestIds, path);
        if (oldTestId) {
            return typeof oldTestId === 'function' ? oldTestId(...args) : oldTestId;
        }
        return getPathWithArgs(path, args);
    };
